import React from 'react';
import * as collectorsAPI from '@debbie/cortex/dist/api/collectors.js';
import keys from '@debbie/common/dist/cache/keys.js';
import { collectorsEntity } from '@debbie/cortex/dist/collectors/index.js';
import PaymentOptionsComponent from '../../PaymentOptions.js';
import q from '@debbie/cortex/dist/query.js';
const PaymentOptions = (props) => {
    const { heading, collectorId, paymentOptions } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("h3", null, heading),
        React.createElement(PaymentOptionsComponent, { collectorId: collectorId, options: paymentOptions, onChange: async (paymentOptions) => {
                try {
                    await collectorsAPI.update(collectorId, {
                        paymentOptions,
                    });
                    q.invalidate(keys.write.modify(collectorsEntity, collectorId));
                }
                catch (err) {
                    console.log(err);
                    alert(err);
                }
            } })));
};
export default PaymentOptions;
//# sourceMappingURL=PaymentOptions.js.map